var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-dataprotection"},[_c('div',{staticClass:"o-container o-container--large"},[_c('section',[_c('translation-tags',{attrs:{"path":"dataProtection.intro"}})],1),_c('translation-tags',{attrs:{"path":"dataProtection.informations"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }